"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var carousel_pips_module_scss_1 = __importDefault(require("./carousel-pips.module.scss"));
var ALPHA_CarouselPips = function (_a) {
    var numberOfPages = _a.numberOfPages, onClick = _a.onClick, currentPage = _a.currentPage;
    return (react_1.default.createElement("ul", { className: (0, classnames_1.default)(carousel_pips_module_scss_1.default['c-carousel-pips']) }, Array.from({ length: numberOfPages }, function (_, index) {
        var _a;
        return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
        react_1.default.createElement("li", { key: index, className: (0, classnames_1.default)(carousel_pips_module_scss_1.default['carousel-pip-item'], (_a = {},
                _a[carousel_pips_module_scss_1.default['pip-click-active']] = currentPage === index,
                _a)), "data-testid": "carousel-pip-".concat(index), onClick: function () { return onClick(index); } }));
    })));
};
exports.default = ALPHA_CarouselPips;
//# sourceMappingURL=CarouselPips.js.map